<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span><i>To My Mother, Margrette Nance Lynch,</i></span></p>
<p class="ded1"><span><i>Who laid the foundation,</i></span></p>
<p class="ded2"><span>and</span></p>
<p class="ded3"><span><i>To my Aunt, Martha Nance Kanowsky,</i></span></p>
<p class="ded1"><span><i>My first editor.</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?60200f18